export default __webpack_public_path__ + "static/media/Grand Finale.0a155d8f.png";